/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { getEntities as getEquipmentIPS } from 'app/entities/equipment-ip/equipment-ip.reducer';
import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getEquipmentIPCharges } from 'app/entities/equipment-ip-charges/equipment-ip-charges.reducer';
import { AllottedByType } from 'app/shared/model/enumerations/allotted-by-type.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { createEntity, getEntity, reset, updateEntity } from './equipment-allotment.reducer';

export const EquipmentAllotmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const admissions = useAppSelector(state => state.admission.entities);
  const equipmentIPS = useAppSelector(state => state.equipmentIP.entities);
  const appointments = useAppSelector(state => state.appointments.entities);
  const equipmentIPCharges = useAppSelector(state => state.equipmentIPCharges.entities);
  const equipmentAllotmentEntity = useAppSelector(state => state.equipmentAllotment.entity);
  const loading = useAppSelector(state => state.equipmentAllotment.loading);
  const updating = useAppSelector(state => state.equipmentAllotment.updating);
  const updateSuccess = useAppSelector(state => state.equipmentAllotment.updateSuccess);
  const allottedByTypeValues = Object.keys(AllottedByType);
  const patientTypeValues = Object.keys(PatientType);

  const handleClose = () => {
    navigate(`/equipment-allotment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAdmissions({}));
    dispatch(getEquipmentIPS({}));
    dispatch(getAppointments({}));
    dispatch(getEquipmentIPCharges({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.allotmentDate !== undefined && typeof values.allotmentDate !== 'number') {
      values.allotmentDate = Number(values.allotmentDate);
    }
    if (values.releaseDate !== undefined && typeof values.releaseDate !== 'number') {
      values.releaseDate = Number(values.releaseDate);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...equipmentAllotmentEntity,
      ...values,
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      equipment: equipmentIPS.find(it => it.id.toString() === values.equipment?.toString()),
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      equipmentCharge: equipmentIPCharges.find(it => it.id.toString() === values.equipmentCharge?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          allottedByType: 'MANAGER',
          releasedByType: 'MANAGER',
          allotmentType: 'OP',
          ...equipmentAllotmentEntity,
          admission: equipmentAllotmentEntity?.admission?.id,
          equipment: equipmentAllotmentEntity?.equipment?.id,
          appointment: equipmentAllotmentEntity?.appointment?.id,
          equipmentCharge: equipmentAllotmentEntity?.equipmentCharge?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.equipmentAllotment.home.createOrEditLabel" data-cy="EquipmentAllotmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.equipmentAllotment.home.createOrEditLabel">
              Create or edit a EquipmentAllotment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="equipment-allotment-id"
                  label={translate('tinyMedicRestApp.equipmentAllotment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.allotmentDate')}
                id="equipment-allotment-allotmentDate"
                name="allotmentDate"
                data-cy="allotmentDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.releaseDate')}
                id="equipment-allotment-releaseDate"
                name="releaseDate"
                data-cy="releaseDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.lastupdated')}
                id="equipment-allotment-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.cursor')}
                id="equipment-allotment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.active')}
                id="equipment-allotment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.allotmentNotes')}
                id="equipment-allotment-allotmentNotes"
                name="allotmentNotes"
                data-cy="allotmentNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.allottedById')}
                id="equipment-allotment-allottedById"
                name="allottedById"
                data-cy="allottedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.releasedById')}
                id="equipment-allotment-releasedById"
                name="releasedById"
                data-cy="releasedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.allottedByType')}
                id="equipment-allotment-allottedByType"
                name="allottedByType"
                data-cy="allottedByType"
                type="select"
              >
                {allottedByTypeValues.map(allottedByType => (
                  <option value={allottedByType} key={allottedByType}>
                    {translate(`tinyMedicRestApp.AllottedByType.${allottedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.releasedByType')}
                id="equipment-allotment-releasedByType"
                name="releasedByType"
                data-cy="releasedByType"
                type="select"
              >
                {allottedByTypeValues.map(allottedByType => (
                  <option value={allottedByType} key={allottedByType}>
                    {translate(`tinyMedicRestApp.AllottedByType.${allottedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.quantity')}
                id="equipment-allotment-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotment.allotmentType')}
                id="equipment-allotment-allotmentType"
                name="allotmentType"
                data-cy="allotmentType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="equipment-allotment-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.equipmentAllotment.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="equipment-allotment-equipment"
                name="equipment"
                data-cy="equipment"
                label={translate('tinyMedicRestApp.equipmentAllotment.equipment')}
                type="select"
              >
                <option value="" key="0" />
                {equipmentIPS
                  ? equipmentIPS.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="equipment-allotment-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.equipmentAllotment.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="equipment-allotment-equipmentCharge"
                name="equipmentCharge"
                data-cy="equipmentCharge"
                label={translate('tinyMedicRestApp.equipmentAllotment.equipmentCharge')}
                type="select"
              >
                <option value="" key="0" />
                {equipmentIPCharges
                  ? equipmentIPCharges.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/equipment-allotment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EquipmentAllotmentUpdate;
